import {
    BooleanInput, DateTimeInput,
    Edit, email, FormDataConsumer, ListButton, PasswordInput,
    required, SaveButton,
    SimpleForm,
    TextInput, Toolbar,
    useEditContext,
} from "react-admin";
import * as React from "react";
import {Card, CardContent, Grid} from "@mui/material";
import UndoIcon from "@mui/icons-material/Undo";


export const EditToolbar = () => {
    const { saving } = useEditContext();
    return (
        <Toolbar>
            <Grid container>
                <Grid item xs={6}>
                    <SaveButton label="保存" size={"medium"}/>
                </Grid>
                <Grid item xs={6} style={{textAlign: 'right'}}>
                    <ListButton disabled={saving} size={"medium"} label="返回" variant={"outlined"} icon={<UndoIcon/>}/>
                </Grid>
            </Grid>
        </Toolbar>
    );
}

const AdminEdit= () => {
    const equalToPassword = (value: any, allValues: { password: any; }) => {
        if (value !== allValues.password) {
            return '兩次密碼不一致';
        }
    }

    return (
        <Card sx={{mt: 2}}>
            <CardContent>
                <Edit mutationMode={"pessimistic"}>
                    <SimpleForm toolbar={<EditToolbar/>} warnWhenUnsavedChanges>
                        <TextInput source="adminId" readOnly={true} label="用戶ID" validate={required("*用戶Id必須填寫")} name="adminId" />
                        <TextInput source="email" label="Email" validate={[required("*用戶Email必須填寫"),email("*郵箱格式不正確")]} name="email"/>
                        <div className={'md:w-2/12 w-full'}>
                            <DateTimeInput source="expiredTime" parse={value => value ? new Date(value).getTime() : -1}  name="expiredTime" label="帳戶過期時間" />
                        </div>
                        <BooleanInput label="修改密碼" source="resetPassword" />
                        <FormDataConsumer>
                            {({formData, scopedFormData,...rest}) => {
                                if (formData.resetPassword) {
                                    return (
                                        <>
                                            <PasswordInput source="password" name="password" label="用戶密碼" validate={required("*密碼必須填寫")} />
                                            <PasswordInput source="confirm_password" name="confirm_password" label="用戶密碼確認" validate={[required("*確認密碼必須填寫"),equalToPassword]} />
                                        </>
                                    )
                                }
                                return null;
                            }}
                        </FormDataConsumer>
                        <TextInput name="remark" multiline resettable rows={7} source="remark" label="帳戶說明"/>
                    </SimpleForm>
                </Edit>
            </CardContent>
        </Card>
    );
}

export default AdminEdit;
